import React from 'react';
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';

import IconAlert from '../svg/IconAlert';
import Password from './Password';

function SplashContainer({ 
  logo, loadingWidth = '50%', loadingColor = 'white', error, 
  hasProtection = false, callback = null, 
  className = 'splash-screen-container-v2'}) 
{
  const loadingPercent = useSelector(state => state.splashLoading);

  return (
    <div className={'flexColumn align center splash-screen'} >
      <div className={`flexColumn align ${className}`}>
        { logo }
        { hasProtection && <Password callback={callback} />}
        { error
          ? (
            <div className={'flexRow align'} style={{gap: 8}}>
              <div width={24}><IconAlert /></div>
              <span className={'splash-error'}>{error.title} - {error.message}</span>
            </div>
          )
          : (!hasProtection 
            ? (
              <div style={{width: loadingWidth, height: 4, background: '#161618' }}>
                <div id="splash_loading" style={{ background: loadingColor }} className={`splash_loading l${loadingPercent}`} />
              </div>
            ) 
            : null)
        }
      </div>
		</div>
  )
}

SplashContainer.propTypes = {
  logo: PropTypes.any.isRequired,
  loadingWidth: PropTypes.any,
  loadingColor: PropTypes.string,
  error: PropTypes.any,
  hasProtection: PropTypes.bool
}

export default SplashContainer;
